import React, { useState } from 'react';

interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
  onNewChat: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar, onNewChat }) => {
  const navItems = [
    { name: 'Home', icon: '🏠' },
    { name: 'Chats', icon: '💬' },
    { name: 'Contacts', icon: '👥' },
    { name: 'Settings', icon: '⚙️' },
    { name: 'Help', icon: '❓' },
  ];

  return (
    <>
      {/* Overlay for mobile when sidebar is open */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" 
          onClick={toggleSidebar}
        ></div>
      )}
      
      {/* Sidebar */}
      <div 
        className={`fixed top-0 left-0 h-full bg-gray-900 text-gray-200 z-30 transition-all duration-300 ease-in-out ${
          isOpen ? 'w-64' : 'w-0 md:w-16'
        } overflow-hidden`}
      >
        <div className="flex flex-col h-full">
          {/* Sidebar Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-700">
            <h2 className={`font-medium text-xl ${!isOpen && 'md:hidden'}`}>ChatAI</h2>
            <button 
              onClick={toggleSidebar} 
              className="text-gray-400 hover:text-white focus:outline-none"
            >
              {isOpen ? '←' : '→'}
            </button>
          </div>
          
          {/* New Chat Button */}
          <div className={`p-4 ${!isOpen && 'md:hidden'}`}>
            <button 
              onClick={onNewChat}
              className="w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md flex items-center justify-center transition-colors"
            >
              <span className="mr-2">+</span>
              <span>New Chat</span>
            </button>
          </div>
          
          {/* Navigation Items */}
          <nav className="flex-1 overflow-y-auto">
            <ul className="py-2">
              {navItems.map((item, index) => (
                <li key={index}>
                  <a 
                    href="#" 
                    className="flex items-center px-4 py-3 hover:bg-gray-800 transition-colors"
                    onClick={(e) => {
                      e.preventDefault();
                      if (item.name === 'Chats' && !isOpen) {
                        onNewChat();
                      }
                    }}
                  >
                    <span className="text-xl mr-3">{item.icon}</span>
                    <span className={!isOpen ? 'md:hidden' : ''}>{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* User Profile */}
          <div className="p-4 border-t border-gray-700 flex items-center">
            <div className="w-8 h-8 rounded-full bg-emerald-500 text-white flex items-center justify-center flex-shrink-0">
              U
            </div>
            <div className={`ml-3 ${!isOpen && 'md:hidden'}`}>
              <div className="font-medium">User</div>
              <div className="text-xs text-gray-400">user@example.com</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
